<div class="main-container">
  <!-- Header -->
  <ui-organism-header/>

  <!-- Router outlet -->
  <main class="main-layout">
    <div class="main-content">
      <router-outlet/>
    </div>
  </main>

  <!-- Footer -->
  <ui-organism-footer/>
</div>
